import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from "../../services/api";

// Thunk to fetch user logs
export const fetchUserLogs = createAsyncThunk(
  "userLogs/fetchUserLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GET("admin/activity", { ...params });
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || "Something went wrong");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Failed to fetch user logs");
    }
  }
);

// http://localhost:5600/api/v1/admin/query?page=1&size=10&sort_order=ASC&sort=created_at

export const fetchQueryLogs = createAsyncThunk(
    "userLogs/fetchQueryLogs",
    async (params = {}, { rejectWithValue }) => {
      try {
        const response = await GET("admin/query", { ...params });
        if (response?.status === 200) {
          return response.data.result;
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to fetch user logs");
      }
    }
  );

// Slice
const LogsSlice = createSlice({
  name: "userLogs",
  initialState: {
    userLogs: [],
    userCount: "",
    loading: false,
    error: null,

    userQueries: [],
    userCountQueries: "",
    loadingQueries: false,
    errorQueries: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.userLogs = action.payload.rows;
        state.userCount = action.payload.count;
      })
      .addCase(fetchUserLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      .addCase(fetchQueryLogs.pending, (state) => {
        state.loadingQueries = true;
        state.errorQueries = null;
      })
      .addCase(fetchQueryLogs.fulfilled, (state, action) => {
        state.loadingQueries = false;
        state.userQueries = action.payload.rows;
        state.userCountQueries = action.payload.count;
      })
      .addCase(fetchQueryLogs.rejected, (state, action) => {
        state.loadingQueries = false;
        state.errorQueries = action.payload || "Something went wrong";
      });
  },
});

export default LogsSlice.reducer;
